import { combineReducers } from 'redux'
import { SubmissionTypeTypes, TemplateTypes } from '../../action_types';
import { arrayToObject, removeItem, updateObjectInArray } from 'src/utils/helpers';

function all(state = {}, action) {
  switch (action.type) {
    case SubmissionTypeTypes.GET_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.GET_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_GET_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ACTIVE_ALL_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.UPDATE_SUBMISSION_TYPES_SUCCESS:
      return arrayToObject(action.data)
    case SubmissionTypeTypes.GET_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ORG_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.UPDATE_SUBMISSION_TYPE_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      }
    case TemplateTypes.DELETE_TEMPLATE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { [action.id]: _, ...newState } = state
      return newState
    default:
      return state
  }
}

function list(state = [], action) {
  switch (action.type) {
    case SubmissionTypeTypes.GET_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.FILTER_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.UPDATE_SUBMISSION_TYPES_SUCCESS:
      return action.data
    case SubmissionTypeTypes.UPDATE_SUBMISSION_TYPE_SUCCESS:
      return updateObjectInArray(state, action.data)
    default:
      return state
  }
}

function org(state = [], action) {
  switch (action.type) {
    case SubmissionTypeTypes.GET_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.FILTER_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.FILTER_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_GET_ORG_SUBMISSION_TYPES_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ACTIVE_ALL_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPES_SUCCESS:
      return action.data
    case SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPE_SUCCESS:
    case SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ORG_SUBMISSION_TYPE_SUCCESS:
      return updateObjectInArray(state, action.data)
    case TemplateTypes.DELETE_TEMPLATE_SUCCESS:
      return removeItem(state, action.id);
    default:
      return state
  }
}

function icons(state = {}, action) {
  switch (action.type) {
    case SubmissionTypeTypes.GET_ICON_SUBMISSION_TYPE_SUCCESS:
      return {
        ...state,
        [action.id]: action.data,
      }
    case SubmissionTypeTypes.UPLOAD_ICON_SUBMISSION_TYPE_SUCCESS:
      return {
        ...state,
        [action.id]: action.image,
      }
    default:
      return state
  }
}
export default combineReducers({
  all,
  list,
  org,
  icons,
})
